<mat-toolbar color="primary" class="page-header mat-elevation-z4">
    <button mat-icon-button (click)="toggleSideNav()">
        <mat-icon>menu</mat-icon>
    </button>
    <img src="assets/kantooropleider.png" />
    <a [routerLink]="['/admin']" class="right-links">Admin</a>
    <span *ngIf="title">&nbsp;- {{title}}</span>
    <span class="spacer"></span>
</mat-toolbar>